<div class="flex flex-col mx-8">
  <div class="my-8 flex flex-row items-center">
    <img
      class="header-logo"
      src="./assets/logo.svg"
      alt="Your Blacklist logo"
    />
    <span class="header-title pl-3">Your Blacklist</span>
  </div>
  <span> Only Google Login is supported for now </span>
  <div class="md:my-20 my-12 flex md:flex-row flex-col justify-between w-100">
    <div class="flex flex-col description-left">
      <span class="">
        Welcome to Your Blacklist, where you can keep track of all your
        blacklisted preferences in one convenient location!
      </span>
      <span class="mt-6">
        This tool is designed to help you organize your preferences in a way
        that is intuitive to you.
      </span>
    </div>
    <div class="md:mr-6 description-right">
      <img src="./assets/homeRightVector.svg" alt="Vector art" />
    </div>
  </div>
</div>

<style>
  .header-logo {
    max-width: 140px;
    width: 5em;
    border-radius: 12px;
  }

  .header-title {
    color: var(--primary-blue);
    font-size: 2em;
    vertical-align: middle;
  }

  .description-left {
    max-width: 40%;
    font-size: 22px;
    line-height: 1.8;
  }

  @media only screen and (max-width: 768px) {
    .description-left {
      max-width: 100%;
      font-size: 16px;
    }

    .description-right {
      margin-top: 4em;
      max-width: 300px;
      @apply mx-auto;
    }
  }
</style>
